export const difYear = (year) => {
    return new Date().getFullYear() - year
}

export const difMarca = (marca) => {
    
    let increment

    switch (marca) {
        case "europeo":
            increment = 1.30
            break
        case "americano":
            increment = 1.15
            break
        case "asiatico": 
            increment = 1.05
            break
    }
    return increment
}

export const difPlan = (plan) => {
    return (plan === "basico") ? 1.20 : 1.50
    
}

export const formatText = (text) => {
    return text.charAt(0).toUpperCase() + text.slice(1)
}